/* Plan unosa jednog listića: skala listića -> UTC dani, spajanje sa postojećim danima, konflikti, payload za snimanje. */
import { listicUIntervale, poDanima, toAppDate, naive, apiNaive, fmtNaive, localToUtc, DAY_MS } from './engine/vreme';
import { addDays, toDateStr } from '../../utils/dates';
import { activityLabel } from '../../utils/activities';

/** Date aplikacije (zidno vreme) -> naivni ms */
const uNaive = (v) => { const x = new Date(v); return naive(x, x.getHours() * 60 + x.getMinutes()); };

export const IZVOR_LABEL = { KARTICA: 'kartica', LISTIC: 'listić', RUCNO: 'ručni unos' };

const MIN = 60000;
const BREAK = 'break/rest';
/** minutni niz dana -> detalji (spojeni po tipu i izvoru) */
const uDetalje = (dan, tip, izv) => {
    const out = [];
    let st = 0;
    for (let i = 1; i <= 1440; i++) {
        if (i === 1440 || tip[i] !== tip[st] || izv[i] !== izv[st]) {
            out.push({ activityType: tip[st], od: dan + st * MIN, do: dan + i * MIN, izvor: izv[st] });
            st = i;
        }
    }
    return out;
};

/**
 * Spajanje dana listića sa postojećim danom (minut po minut).
 *   nacin 'zameni'  u periodu listića važe aktivnosti sa listića (postojeće van perioda ostaje)
 *         'zadrzi'  postojeće aktivnosti ostaju; listić popunjava samo odmor / prazno u svom periodu
 * izvor reda: 'postoji' (prethodni unos), 'novo' (sa listića), null (dopunski odmor)
 * konflikt = postojeće aktivnosti osim odmora koje se preklapaju sa periodom listića
 */
export function spojiDanNacin(d, postojeci, nacin = 'zameni') {
    const tip = new Array(1440).fill(BREAK), izv = new Array(1440).fill(null);
    const stari = (postojeci || []).map((x) => {
        const s = new Date(x.startTime), e = new Date(x.endTime);
        return { activityType: x.activityType, od: naive(s, s.getHours() * 60 + s.getMinutes()), do: naive(e, e.getHours() * 60 + e.getMinutes()) };
    }).filter((x) => x.do > x.od);
    const mi = (ms) => Math.max(0, Math.min(1440, Math.round((ms - d.dan) / MIN)));
    stari.forEach((x) => { for (let i = mi(x.od); i < mi(x.do); i++) { tip[i] = x.activityType; izv[i] = 'postoji'; } });
    const a = mi(d.od), b = mi(d.do);
    if (nacin === 'zameni') for (let i = a; i < b; i++) { tip[i] = BREAK; izv[i] = 'novo'; }
    d.intervali.forEach((x) => {
        for (let i = mi(x.od); i < mi(x.do); i++) {
            if (nacin === 'zadrzi' && izv[i] === 'postoji' && tip[i] !== BREAK) continue; // eslint-disable-line no-continue
            tip[i] = x.type; izv[i] = 'novo';
        }
    });
    if (nacin === 'zadrzi') for (let i = a; i < b; i++) if (izv[i] !== 'novo' && tip[i] === BREAK) izv[i] = 'novo';
    const konflikt = stari.filter((x) => x.activityType !== BREAK && x.od < d.do && x.do > d.od);
    return { detalji: uDetalje(d.dan, tip, izv), konflikt, postojeciDetalji: stari };
}

/** aktivnosti listića (sve osim odmora) u minutima skale: izmenjene od strane operatera ili prepoznate */
export const aktivnostiOf = (item) => (item.aktivnosti
    || (item.result ? item.result.segments.filter((s) => s.type && s.type !== 'break/rest').map((s) => ({ start: s.start, end: s.end, type: s.type })) : []));

/** naivni UTC ms -> lokalno (Beograd) zidno vreme */
const utcULokal = (u) => (localToUtc(u + 7200000) === u ? u + 7200000 : u + 3600000);

/**
 * Izmena tabele dana (operater) -> patch stavke, da listić, traka i tabela uvek pokazuju isto:
 *   u periodu listića tog dana izmena se upisuje u aktivnosti skale listića (kao izmena na slici);
 *   van perioda listića (postojeće aktivnosti dana) čuva se kao ručna izmena dana, samo ako se razlikuje od izračunatog.
 * @param d      dan plana ({ dan, od, do }, naivni UTC ms)
 * @param lista  detalji iz tabele [{ activityType, startTime, endTime, izvor }] (Date aplikacije)
 */
export function izmenaDana(item, d, lista, srednja = 'availability') {
    const base = naive(item.datumOd);
    const redovi = lista.map((x) => ({ type: x.activityType, od: uNaive(x.startTime), do: uNaive(x.endTime), izvor: x.izvor }));
    const naMinutu = (t) => redovi.find((x) => x.od <= t && t < x.do);
    /* skala listića: minut -> tip (null = odmor) */
    const m = new Array(1440).fill(null);
    aktivnostiOf(item).forEach((a) => { for (let i = Math.max(0, a.start); i < Math.min(1440, a.end); i++) m[i] = a.type; });
    for (let t = d.od; t < d.do; t += MIN) {
        const r = naMinutu(t);
        const tip = r ? r.type : BREAK;
        const sk = ((Math.round((utcULokal(t) - base) / MIN) % 1440) + 1440) % 1440;
        /* srednja traka listića je 'availability' i kad znači ostali rad (mapirano) */
        m[sk] = tip === BREAK ? null : srednja !== 'availability' && tip === srednja ? 'availability' : tip;
    }
    const aktivnosti = [];
    for (let i = 0; i < 1440; i++) {
        const z = aktivnosti[aktivnosti.length - 1];
        if (!m[i]) continue; // eslint-disable-line no-continue
        if (z && z.type === m[i] && z.end === i) z.end = i + 1; else aktivnosti.push({ start: i, end: i + 1, type: m[i] });
    }
    /* van perioda listića: poređenje sa izračunatim danom (bez ručne izmene) */
    const rr = { ...(item.rucno || {}) };
    delete rr[d.dan];
    const novi = napraviPlan({ ...item, aktivnosti, rucno: null }, srednja);
    const izr = novi && novi.dani.find((x) => x.dan === d.dan);
    const van = [];
    let razlika = false;
    for (let t = d.dan; t < d.dan + DAY_MS; t += MIN) {
        if (t >= d.od && t < d.do) continue; // eslint-disable-line no-continue
        /* obrisan red van perioda listića = odmor (dan uvek ima 24 h; ranije je ostajala rupa i dan nije mogao da se unese) */
        const r = naMinutu(t) || { type: BREAK };
        const z = izr && izr.detalji.find((x) => x.od <= t && t < x.do);
        const isto = r && z && r.type === z.activityType;
        if (!isto) razlika = true;
        const izvor = isto ? z.izvor : 'rucno';
        const p = van[van.length - 1];
        if (p && p.activityType === r.type && p.izvor === izvor && p.do === t) p.do = t + MIN;
        else van.push({ activityType: r.type, od: t, do: t + MIN, izvor });
    }
    if (razlika) rr[d.dan] = van.map((x) => ({ activityType: x.activityType, startTime: toAppDate(x.od), endTime: toAppDate(x.do), izvor: x.izvor }));
    return { aktivnosti, rucno: rr };
}

/** pun krug skale: odmor, "listić nije uložen" (iz prepoznavanja) i preko toga aktivnosti (kasnija u spisku ima prednost) */
export function segmentiOf(item) {
    if (!item.result) return [];
    const m = new Array(1440).fill('break/rest');
    const r = item.result;
    /* operater je pomerio početak aktivnosti: "listić nije uložen" traje od vađenja do novog početka */
    if (r.prazno && item.ulaganje != null && item.ulaganje !== r.ulaganje) {
        for (let i = r.vadjenje % 1440; i !== item.ulaganje % 1440; i = (i + 1) % 1440) m[i] = null;
    } else r.segments.forEach((s) => { if (!s.type) for (let i = s.start; i < s.end; i++) m[i] = null; });
    aktivnostiOf(item).forEach((a) => { for (let i = Math.max(0, a.start); i < Math.min(1440, a.end); i++) m[i] = a.type; });
    const out = [];
    let st = 0;
    for (let i = 1; i <= 1440; i++) if (i === 1440 || m[i] !== m[st]) { out.push({ start: st, end: i, type: m[st] }); st = i; }
    return out;
}

/** segmenti sa zamenom značenja srednje trake (raspoloživost / ostali rad) */
const mapirano = (segments, srednja) => segments.map((s) => (s.type === 'availability' && srednja !== 'availability' ? { ...s, type: srednja } : s));

/**
 * @param item     stavka bulk-a (result, datumOd, ulaganje, km, provera)
 * @param srednja  'availability' | 'work'
 * @returns null (nedostaje datum/rezultat) ili
 *   { lokalno, utc, datumDo, dani: [{ dan, od, do, detalji, konflikt, izvor, postoji }], konflikt: bool }
 */
export function napraviPlan(item, srednja = 'availability') {
    if (!item || !item.result || !item.datumOd) return null;
    const L = listicUIntervale(mapirano(segmentiOf(item), srednja), item.datumOd, item.ulaganje);
    if (!L.lokalno) return null;
    const postojeci = (item.provera && item.provera.postojeci) || [];
    const izvori = (item.provera && item.provera.izvori) || {};
    const delovi = poDanima(L.intervali, L.utc);
    /* listić je po lokalnom vremenu, a dani su UTC: listić koji je ceo dan u tahografu (00–24 h Beograd) zahvata i 1–2 h
       susednog UTC dana (pomeraj Beograda). Takav krajnji deo sa SAMO odmorom se podrazumevano ne unosi — taj dan dopunjuje
       odmorom njegov listić (praznine su odmor), a ranije je bulk za svaki listić nudio dva dana. Operater ga može uključiti. */
    const samoOdmorKraj = (d) => delovi.length > 1 && d.do - d.od <= 2 * 3600000 && d.intervali.every((x) => x.type === BREAK);
    const dani = delovi.map((d) => {
        const p = postojeci.find((x) => naive(new Date(x.activityDate)) === d.dan);
        const nacin = (item.naciniDana && item.naciniDana[d.dan]) || (samoOdmorKraj(d) ? 'preskoci' : 'zameni');
        const s = spojiDanNacin(d, p ? p.activityDetails : null, nacin === 'preskoci' ? 'zadrzi' : nacin);
        const out = { ...d, ...s, nacin, preskocen: nacin === 'preskoci', postoji: !!p, izvor: izvori[d.dan] || null };
        /* ručna izmena dana VAN perioda listića (u periodu listića izmena iz tabele ide na sam listić — izmenaDana) */
        const rucno = item.rucno && item.rucno[d.dan];
        if (rucno) {
            const tip = new Array(1440).fill(undefined), izv = new Array(1440).fill(null);
            const mi = (ms) => Math.max(0, Math.min(1440, Math.round((ms - d.dan) / MIN)));
            const a = mi(d.od), b = mi(d.do);
            s.detalji.forEach((x) => { for (let i = Math.max(a, mi(x.od)); i < Math.min(b, mi(x.do)); i++) { tip[i] = x.activityType; izv[i] = x.izvor; } });
            rucno.forEach((x) => {
                for (let i = mi(uNaive(x.startTime)); i < mi(uNaive(x.endTime)); i++) if (i < a || i >= b) { tip[i] = x.activityType; izv[i] = x.izvor === undefined ? 'rucno' : x.izvor; }
            });
            out.rucno = true;
            out.detalji = uDetalje(d.dan, tip, izv).filter((x) => x.activityType !== undefined);
            out.suma = out.detalji.reduce((z, x) => z + (x.do - x.od), 0);
        }
        return out;
    });
    /* pređeni put: razlika kilometraže deli se po danima srazmerno vožnji */
    const km = item.kmOd != null && item.kmDo != null && item.kmDo >= item.kmOd ? item.kmDo - item.kmOd : null;
    if (km != null) {
        const voznja = dani.map((d) => d.intervali.filter((x) => x.type === 'driving').reduce((a, x) => a + x.do - x.od, 0));
        const ukupno = voznja.reduce((a, b) => a + b, 0);
        let ostatak = km;
        dani.forEach((d, i) => {
            d.km = i === dani.length - 1 ? ostatak : ukupno ? Math.round((km * voznja[i]) / ukupno) : 0;
            ostatak -= d.km;
        });
    }
    return {
        lokalno: L.lokalno,
        utc: L.utc,
        datumDo: addDays(item.datumOd, Math.floor((L.lokalno.do - 1 - naive(item.datumOd)) / DAY_MS)),
        dani,
        konflikt: dani.some((d) => d.konflikt.length && !d.preskocen),
        /* zamena = bar jedan dan sa konfliktom u kome listić menja postojeće */
        zamena: dani.some((d) => d.konflikt.length && d.nacin === 'zameni'),
        neispravno: dani.some((d) => d.rucno && d.suma !== DAY_MS),
        prazno: dani.every((d) => d.preskocen),
    };
}

/** tekst postojećih aktivnosti (za napomenu u evidenciji i prikaz) */
export const opisKonflikta = (plan) => plan.dani.filter((d) => d.konflikt.length).map((d) => `${fmtNaive(d.dan, false)}: ${d.konflikt
    .map((k) => `${activityLabel(k.activityType)} ${fmtNaive(k.od).slice(11)}–${fmtNaive(k.do).slice(11)}`).join(', ')}`).join('; ');

const prviIzvor = (plan) => (plan.dani.find((d) => d.konflikt.length) || {}).izvor || null;

/** zapis listića za evidenciju */
export const zapisListica = (item, plan) => ({
    fileName: item.name,
    sha256: item.sha256,
    pocetakLokalno: apiNaive(plan.lokalno.od),
    krajLokalno: apiNaive(plan.lokalno.do),
    pocetakUtc: apiNaive(plan.utc.od),
    krajUtc: apiNaive(plan.utc.do),
    datumOd: toDateStr(item.datumOd),
    datumDo: toDateStr(plan.datumDo),
    izvor: plan.konflikt ? prviIzvor(plan) : null,
    napomena: plan.konflikt ? opisKonflikta(plan).slice(0, 1000) : null,
    pouzdanost: Math.round(item.result.pouzdanost * 10000) / 100,
    kmPocetak: item.kmOd,
    kmKraj: item.kmDo,
});

/** dani za snimanje (pun dan, 24 h) */
export const daniZaSnimanje = (plan) => plan.dani.filter((d) => !d.preskocen).map((d) => ({
    activityDate: toAppDate(d.dan),
    traversedDistance: d.km || 0,
    activityDetails: d.detalji.map((x) => ({ activityType: x.activityType, startTime: toAppDate(x.od), endTime: toAppDate(x.do) })),
}));

/**
 * Predlog datuma ulaganja bez čitanja rukopisa: listić nastavlja prethodni listić istog vozača (redosled u spisku).
 * Ako je uložen posle sata vađenja prethodnog -> isti dan kao vađenje, inače sledeći dan.
 * @returns { datum: Date, od: ime prethodnog listića } ili null
 */
export function predlogDatuma(items, i, planovi) {
    const item = items[i];
    if (!item || !item.driver || !item.result) return null;
    for (let j = i - 1; j >= 0; j--) {
        const prev = items[j];
        if (!prev.driver || prev.driver.id !== item.driver.id) continue; // eslint-disable-line no-continue
        if (!prev.datumOd) return null; // prethodni listić istog vozača još nema datum — niz čeka
        const pp = planovi(prev);
        /* listić bez zapisa (prazan, "PAUZA") nema vreme vađenja: sledeći je dan posle njegovog datuma */
        const prazan = !pp || !prev.result || !prev.result.segments || prev.result.segments.every((s) => !s.type);
        if (prazan) return { datum: toAppDate(naive(prev.datumOd) + DAY_MS), od: prev.name };
        const vadjenje = pp.lokalno.do;
        const dan = Math.floor(vadjenje / DAY_MS) * DAY_MS;
        const minut = (vadjenje - dan) / 60000;
        /* ovaj listić je prazan (nema vreme ulaganja): stavljen je kad je prethodni izvađen — isti dan */
        const ovajPrazan = !item.result.segments || item.result.segments.every((s) => !s.type);
        if (ovajPrazan) return { datum: toAppDate(dan), od: prev.name };
        return { datum: toAppDate(item.ulaganje >= minut ? dan : dan + DAY_MS), od: prev.name };
    }
    return null;
}

/**
 * Pomeranje segmenata skale za delta minuta (prikaz u UTC: delta = -pomeraj; nazad: +pomeraj).
 * Segment koji pređe ponoć deli se na dva; susedni istog tipa se spajaju. Radi i za pune segmente (odmor, "nema").
 */
export function pomeri(lista, delta) {
    if (!delta) return lista.map((a) => ({ ...a }));
    const out = [];
    lista.forEach((a) => {
        let s = a.start + delta, e = a.end + delta;
        if (e <= 0) { s += 1440; e += 1440; } else if (s >= 1440) { s -= 1440; e -= 1440; }
        if (s < 0) { out.push({ ...a, start: s + 1440, end: 1440 }); out.push({ ...a, start: 0, end: e }); }
        else if (e > 1440) { out.push({ ...a, start: s, end: 1440 }); out.push({ ...a, start: 0, end: e - 1440 }); }
        else out.push({ ...a, start: s, end: e });
    });
    out.sort((x, y) => x.start - y.start);
    const spojeno = [];
    out.forEach((a) => {
        const z = spojeno[spojeno.length - 1];
        if (z && z.type === a.type && z.end === a.start) z.end = a.end; else spojeno.push({ ...a });
    });
    return spojeno;
}
